import { InfoSet } from "../InfoSets/InfoSet";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";
  
export abstract class InfoSetTable<K, V> extends InfoSet /*implements ISerializable*/ {
    protected _table: Dictionary<K, V>;

    constructor(device: Device) {
        super(device);
        this._table = new Dictionary<K, V>();
    }

    public Clear(): void {
        this._table.Clear();
    }

    public get Count(): number {
        return this._table.Count;
    }
        
    public ContainsKey(key: K) :boolean{
        return this._table.ContainsKey(key);
    }

    public GetFirstValue(): V {
        var firstKvp = this._table.First();
        if (firstKvp != null) {
            return firstKvp.Value;
        }
        return null;
    }

    public GetValue(key: K): V {
        return this._table.Item(key);
    }

    public Remove(key: K): boolean {
            return this._table.Remove(key);
    }

    public ToArray(): V[] {
        return this._table.Values().Values;
    }

    public ForEach(callbackfn: (value: V, index: number, array: V[]) => void, thisArg?: any): void {
        this._table.Values().ForEach(callbackfn, thisArg);
    }

    public Some(callbackfn: (value: V, index: number, array: V[]) => boolean, thisArg?: any): boolean {
        return this._table.Values().Some(callbackfn, thisArg);
    }

    public Every(callbackfn: (value: V, index: number, array: V[]) => boolean, thisArg?: any): boolean {
        return this._table.Values().Every(callbackfn, thisArg);
    }

    //public Deserialize(json: any): void {
    //    var entries = json.entries;
    //    this.Clear();
    //    for (var entryKey in entries) {
    //        this.DeserializeEntry(entries[entryKey][this.EntryName()]);
    //    }
    //}
        
    //abstract DeserializeEntry(json: any): void;
    //abstract EntryName():string;
}
